<template>
  <v-app>
    <div id="campaign-report">
        <div v-if="reportData.campaign">
            <div>
                <div class="hero-container">
                    <v-img src='/static/img/report/html-rpt-bg.jpg'
                    aspect-ratio="1.7"
                    gradient="to bottom right, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, .7)"
                    >
                    </v-img>
                </div>
                <div class="client">
                    <v-img :src="reportData.campaign.client.logo" class="client-logo"></v-img>
                    <div class="client-name">{{reportData.campaign.client.name}}</div>
                    <div class="current-date">{{formatedCurrentDate}}</div>
                </div>
                <div class="campaign">
                        {{reportData.campaign.name}}
                        <div class="objective-div">
                        <div class="objectives-title" >
                            Objectives
                            <ul class="objective">
                                <li v-for="(item, index) in reportData.campaign.objectives" :key="index">
                                    {{item}}
                                </li>
                            </ul>
                        </div>
                        <div class="deliverable-title" >
                            Deliverables
                            <ul class="deliverable">
                                <li v-for="(item, index) in reportData.campaign.deliverables" :key="index">
                                    {{item}}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <a href="#post"><div class="scroll"></div></a>
                </div>
                <!-- <div style="position:absolute;bottom:10px;right:20px;">
                    <v-img src="/static/img/report/android-icon-72x72.png" ></v-img>
                </div> -->
            </div>
            <div id="sideNavContents">
              <v-card dark max-width="180">
                <v-navigation-drawer
                v-model="drawer"
                :mini-variant.sync="mini"
                permanent
                right
                expand-on-hover
                dark
                >

                <v-list color="#212121" dense>
                    <v-list-item link href="#campaignSummary">
                        <v-list-item-icon style="margin-right: 32px;">
                            <v-icon>mdi-file-check</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Campaign Summary</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item link href="#postSummary" v-show="reportData.campaign.enablePostAnalysis && postsAnalysisData.length > 0">
                        <v-list-item-icon style="margin-right: 32px;">
                            <v-icon>mdi-image-multiple</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Post Summary</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item link href="#reelSummary" v-show="reportData.campaign.enableReelAnalysis && reelAnalysisData.length > 0">
                        <v-list-item-icon style="margin-right: 32px;">
                            <v-icon>mdi-movie-roll</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Reel Summary</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-show="storyAnalysisData.length > 0" link href="#storySummary">
                        <v-list-item-icon style="margin-right: 32px;">
                            <v-icon>mdi-movie-open</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Story Summary</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-show="reportData.campaign.enableTikTokAnalysis && tikTokAnalysisData.length > 0" link href="#tiktokSummary">
                        <v-list-item-icon style="margin-right: 32px;">
                          <v-img src='/static/img/tik-tok-white.png' aspect-ratio="1"></v-img>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>TikTok Summary</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-show="reportData.campaign.enableYoutubeAnalysis && youtubeAnalysisData.length > 0" link href="#youtubeSummary">
                        <v-list-item-icon style="margin-right: 32px;">
                          <i class="fab fa-youtube" style="font-size:25px"></i>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Youtube Summary</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-show="reportData.campaign.enableFbAnalysis && fbAnalysisData.length > 0" link href="#fbSummary">
                        <v-list-item-icon style="margin-right: 32px;">
                          <i class="fab fa-facebook" style="font-size:25px"></i>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Facebook Summary</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-show="reportData.campaign.enableLinkedInAnalysis && linkedInAnalysisData.length > 0" link href="#linkedInSummary">
                        <v-list-item-icon style="margin-right: 32px;">
                          <v-icon>mdi-linkedin</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>LinkedIn Summary</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-show="reportData.campaign.enableTwitterAnalysis && twitterAnalysisData.length > 0" link href="#twitterSummary">
                      <v-list-item-icon style="margin-right: 32px;"><span class="report-nav-x-logo" role="img" aria-label="X (Twitter)"></span></v-list-item-icon>
                      <v-list-item-content><v-list-item-title>X (Twitter) Summary</v-list-item-title></v-list-item-content>
                    </v-list-item>
                    <v-list-item v-show="reportData.campaign.enableXHSAnalysis && xhsAnalysisData.length > 0" link href="#xhsSummary">
                        <v-list-item-icon style="margin-right: 32px;">
                          <v-icon>mdi-file-outline</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>XHS Summary</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-show="reportData.campaign.enableLemonAnalysis && lemonAnalysisData.length > 0" link href="#lemonSummary">
                        <v-list-item-icon style="margin-right: 32px;">
                          <v-icon>mdi-file-outline</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Lemon8 Summary</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item link href="#performance" v-show="reportData.campaign.enableOverallSection">
                        <v-list-item-icon style="margin-right: 32px;">
                            <v-icon>mdi-chart-bar</v-icon>
                        </v-list-item-icon>

                        <v-list-item-content>
                            <v-list-item-title>Overall</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
                </v-navigation-drawer>
              </v-card>
            </div>
            <v-fab-transition>
                <v-btn
                id="goTop"
                elevation="24"
                color="#3F3FFF"
                class="fab-btn-up"
                fab
                small
                fixed
                bottom
                right
                raised
                @click="scrollTopFunction"
                ><v-icon>mdi-menu-up</v-icon></v-btn>
            </v-fab-transition>
            <div id="campaignSummary">
              <campaign-summary :campaign="reportData.campaign" />
            </div>
            <section id="postSummary" v-if="reportData.campaign.enablePostAnalysis && postsAnalysisData.length > 0">
              <post-summary :posts="postsAnalysisData" :campaign="reportData.campaign" />
            </section>
            <section id="reelSummary" v-if="reportData.campaign.enableReelAnalysis && reelAnalysisData.length > 0">
              <reel-summary :posts="reelAnalysisData" :campaign="reportData.campaign" />
            </section>
            <section id="storySummary" v-if="storyAnalysisData.length > 0" >
              <story-summary :posts="storyAnalysisData" :campaign="reportData.campaign" />
            </section>
            <section id="tiktokSummary" v-if="reportData.campaign.enableTikTokAnalysis && tikTokAnalysisData.length > 0">
              <tiktok-summary :posts="tikTokAnalysisData" :campaign="reportData.campaign" />
            </section>
            <section id="youtubeSummary" v-if="reportData.campaign.enableYoutubeAnalysis && youtubeAnalysisData.length > 0">
              <youtube-summary :posts="youtubeAnalysisData" :campaign="reportData.campaign" />
            </section>
            <section id="fbSummary" v-if="reportData.campaign.enableFbAnalysis && fbAnalysisData.length > 0">
              <fb-summary :posts="fbAnalysisData" :campaign="reportData.campaign" />
            </section>
            <section id="linkedInSummary" v-if="reportData.campaign.enableLinkedInAnalysis && linkedInAnalysisData.length > 0">
              <fb-summary summaryType="linkedin" :posts="linkedInAnalysisData" :campaign="reportData.campaign" :defaultCols="defaultLinkedInAnalysisStatus" />
            </section>
            <section id="twitterSummary" v-if="reportData.campaign.enableTwitterAnalysis && twitterAnalysisData.length > 0">
              <fb-summary summaryType="twitter" :posts="twitterAnalysisData" :campaign="reportData.campaign" :defaultCols="defaultTwitterAnalysisStatus" />
            </section>
            <section id="xhsSummary" v-if="reportData.campaign.enableXHSAnalysis && xhsAnalysisData.length > 0">
              <xhs-summary :posts="xhsAnalysisData" :campaign="reportData.campaign" />
            </section>
            <section id="lemonSummary" v-if="reportData.campaign.enableLemonAnalysis && lemonAnalysisData.length > 0">
              <lemon-summary :posts="lemonAnalysisData" :campaign="reportData.campaign" />
            </section>
            <section id="performance" v-if="reportData.campaign.enableOverallSection">
                <campaign-performance
                :posts="postsAnalysisData"
                :reels="reelAnalysisData"
                :tikTokPosts="tikTokAnalysisData"
                :youtubePosts="youtubeAnalysisData"
                :summary="reportData.campaign.summary"
                :campaignID="reportData.campaign.id"
                :campaignKPI="reportData.campaign.kpi"
                :campaign="reportData.campaign"/>
            </section>
            <div id="post" >
              <div v-for="(item, index) in campaignPosts" :key="index">
                  <div v-if="item.reportGroup && item.reports.length > 0">
                    <v-container>
                      <v-expansion-panels v-model="item.panel" multiple dark accordion focusable>
                        <v-expansion-panel expand>
                          <v-expansion-panel-header>
                            <v-toolbar-title>
                              {{item.name}} ({{item.reports.length}})
                            </v-toolbar-title>
                          </v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <posts v-for="(item2, index) in item.reports " :type="item2.type" :post="item2" :campaign="reportData.campaign" :key="index"/>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-container>
                  </div>
                  <div v-else>
                    <posts :type="item.type" :post="item" :key="index" :campaign="reportData.campaign"/>
                  </div>
              </div>
              <!-- <infinite-loading @infinite="getCampaignPosts" :identifier="infiniteId">
                <div slot="no-more"></div>
                <div slot="no-results"></div>
              </infinite-loading> -->
            </div>
            <!-- <v-divider color="#212121"></v-divider> -->
            <v-footer padless color="#000000" class="report-footer">
                <v-col
                class="text-center"
                cols="12"
                >
                <div style="width:72px;margin-left:auto;margin-right:auto">
                <v-img :src="kobeGreenLogo" width="72px" ></v-img>
                </div>
                <a href="https://www.getkobe.com" target="_blank" style="color:white;">www.getkobe.com</a>
                </v-col>
            </v-footer>
        </div>
        <!-- CreateCampaign modal -->
        <report-login-modal v-model="loginModalDialog" :value="loginModalDialog" :campaignID="campaignID" @loggedIn="loggedIn" />
    </div>
  </v-app>

</template>

<script>
/* eslint-disable */
import AOS from 'aos';
import 'aos/dist/aos.css';
// import InfiniteLoading from 'vue-infinite-loading';
import moment from 'moment'
// import CampaignData from './data'
import posts from './posts'
import CampaignSummary from './CampaignSummary'
import PostSummary from './PostSummary'
import ReelSummary from './ReelSummary'
import StorySummary from './StorySummary'
import TiktokSummary from './TiktokSummary'
import YoutubeSummary from './YoutubeSummary'
import FbSummary from './FbSummary'
import XhsSummary from './XHSSummary'
import LemonSummary from './LemonSummary'
import campaignPerformance from './performance'
import campaignAPIs from '../views/Campaign/campaignAPIs'
import ReportLoginModal from './ReportLoginModal'
import campaignHelper from '../views/Campaign/campaignHelper'
import { getReportPlatform, getReportProfileUrl } from '@/utils/reportPlatform'
import utils from '../../utils'
import kobeGreenLogo from '@/assets/Kobe Logo Green.png'

export default {
  name: 'Reports',
  components: {
    ReportLoginModal,
    posts,
    CampaignSummary,
    PostSummary,
    ReelSummary,
    StorySummary,
    TiktokSummary,
    YoutubeSummary,
    FbSummary,
    XhsSummary,
    LemonSummary,
    campaignPerformance
    // InfiniteLoading
  },
  data () {
    return {
      campaignID: '',
      passcode: '',
      kobeGreenLogo,
      loginModalDialog: false,
      reportData: {campaign: null},
      postsAnalysisData: [],
      reelAnalysisData: [],
      storyAnalysisData: [],
      tikTokAnalysisData: [],
      youtubeAnalysisData: [],
      xhsAnalysisData: [],
      lemonAnalysisData: [],
      fbAnalysisData: [],
      linkedInAnalysisData: [],
      twitterAnalysisData: [],
      allPosts: [],
      campaignPosts: [],
      defaultPostsAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showReach: false,
        showImpressions: false,
        likes: true,
        showShares: true,
        comments: true,
        showBookmarks: true,
        showInteractions: false,
        showEngagement: true,
        showEngRateReach: false,
        showAvgEngagement: false,
        showMediaEngagement: true,
        showAvgLikes: false,
        showAvgComments: false,
        showAvgViews: false
      },
      defaultReelAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showReach: false,
        showImpressions: false,
        likes: true,
        showShares: true,
        comments: true,
        showBookmarks: true,
        showInteractions: false,
        showViews: true,
        showPlays: false,
        showWatches: false,
        showEngagement: false,
        showEngagementView: true,
        showInteractionPlays: true,
        showEngRateReach: false,
        showAvgEngagement: false,
        showMediaEngagement: true,
        showAvgLikes: false,
        showAvgComments: false,
        showAvgViews: false,
        showAvgReelsPlays: false
      },
      defaultStoryAnalysisStatus: {
        liveDate: false,
        outreach: true,
        showReach: false,
        showImpressions: true,
        showStoryLikes: true,
        showReplies: true,
        showShares: true,
        showLinkClicks: true,
        showStickerTaps: true,
        showInteractions: false,
        showNewEngagementRate: false,
        showAvgViews: false,
        showAvgReelsPlays: false
      },
      defaultTikTokAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showPlays: true,
        showWatches: true,
        likes: true,
        comments: true,
        shares: true,
        showBookmarks: true,
        showInteractions: false,
        showViews: false,
        showReach: false,
        showImpressions: false,
        avgViews: false,
        avgLikes: false,
        avgComments: false,
        avgSaves: false,
        avgShares: false,
        showEngagement: false,
        showEngagementView: true,
        showInteractionPlays: true,
        showEngRateTotalViewers: false,
        showAvgEngagement: false,
        showMediaEngagement: false,
        showWatchedFullVideo: false,
        showPhotoViews: false
      },
      defaultYoutubeAnalysisStatus: {
        liveDate: false,
        url: true,
        outreach: true,
        showViews: true,
        likes: true,
        comments: true,
        showInteractions: false,
        avgViews: false,
        avgLikes: false,
        avgComments: false,
        showEngagement: true,
        showEngagementView: false,
        showAvgEngagement: false,
        showMediaEngagement: false
      },
      defaultPerformanceAnalysisStatus: {
        totalContents: true,
        totalOutreach: true,
        contents: true,
        outreach: true,
        interactions: true,
        outreachImpressions: true,
        postEngRate: false,
        reelEngRate: false,
        tiktokEngRate: false,
        youtubeEngRate: false,
        postEngRateView: false,
        reelEngRateView: false,
        tiktokEngRateView: false,
        youtubeEngRateView: false,
        industryBenchmark: false
      },
      defaultXHSAnalysisStatus: {
        liveDate: true,
        outreach: true,
        showViews: true,
        showWatches: false,
        showLikes: true,
        showBookmarks: false,
        showComments: true,
        showShares: true,
        showInteractions: false
      },
      defaultLemonAnalysisStatus: {
        liveDate: true,
        outreach: true,
        showViews: true,
        showWatches: false,
        showLikes: true,
        showBookmarks: false,
        showComments: true,
        showShares: true,
        showInteractions: false
      },
      defaultFbAnalysisStatus: {
        liveDate: true,
        outreach: true,
        showLikes: true,
        showComments: true,
        showViews: true,
        showShares: true,
        showBookmarks: false,
        showInteractions: false
      },
      defaultLinkedInAnalysisStatus: {
        liveDate: true,
        url: true,
        showImpressions: true,
        showReach: true,
        showVideoViews: true,
        showProfileViewers: true,
        showLikes: true,
        showComments: true,
        showShares: true,
        showBookmarks: true,
        showInteractions: false
      },
      defaultTwitterAnalysisStatus: {
        liveDate: true,
        url: true,
        showImpressions: true,
        showComments: true,
        showLikes: true,
        showShares: true,
        showBookmarks: true,
        showInteractions: false
      },
      drawer: true,
      items: [
        { title: 'Home', icon: 'mdi-home-city' },
        { title: 'My Account', icon: 'mdi-account' },
        { title: 'Users', icon: 'mdi-account-group-outline' }
      ],
      mini: true,
      infiniteId: +new Date(),
      page: 1
    }
  },
  computed: {
    isLoggedIn() {
      if (this.$store.state.token && this.$store.state.token !== 'null' && this.$store.state.user) {
        return true
      }
      return false
    },
    formatedCurrentDate() {
      return moment(Date.now()).format('MMM - DD, yyyy')
    }
  },
  created() {
    AOS.init()
    window.onscroll = function() {
      setTimeout(function() {
        let favBtn = document.getElementById('goTop')
        // console.log('Scroll Top', document.documentElement.scrollTop)
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 800) {
          favBtn.style.display = 'block';
        } else {
          favBtn.style.display = 'none'
        }
      }, 500)
    }
  },
  mounted() {
    if (Object.keys(this.$route.query).length === 0) {
      this.$swal({
        type: 'error',
        title: 'Invalid ID',
        text: 'Please Reload with a valid ID'
      })
    } else {
      this.campaignID = this.$route.query.id
      if (this.isLoggedIn) {
        this.clearReportAuthLocalStorage()
        this.getCampaignReport()
        // this.getCampaignPosts()
      } else {
        this.checkPasscodeLoggedIn()
      }
    }
  },
  watch: {
    reportData(newData) {
      this.reportData = newData
    }
  },
  methods: {
    scrollTopFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    async getCampaignReport() {
      let force = false;
      let campaignID = this.$route.query.id
      this.isLoading = true;
      try {
        let response;
        if (this.isLoggedIn) {
          response = await campaignAPIs.generateCampaignReport(campaignID, null, force)
        } else {
          response = await campaignAPIs.generateCampaignHTMLReport(campaignID, this.passcode, null, force)
        }
        if (response.success) {
          let respData = response.data;
          let campaign = {};
          campaign.id = respData.campaign_details.id;
          campaign.name = respData.campaign_details.name;
          campaign.campaignType = respData.campaign_details.campaignType;
          campaign.objectives = respData.campaign_details.goal;
          campaign.deliverables = [`Total ${respData.summary.contents} contents`];
          campaign.angles = respData.campaign_details.angles ? campaignHelper.fixAnglesData(respData.campaign_details.angles) : []
          campaign.segment = respData.campaign_details.segment || campaignHelper.getDefaultSegments()
          campaign.lineUp = respData.campaign_details.lineUp || []
          const settings = respData.campaign_details.settings || {}
          campaign.enablePostAnalysis = settings.enablePostAnalysis !== false;
          campaign.enableReelAnalysis = settings.enableReelAnalysis !== false;
          campaign.enableTikTokAnalysis = settings.enableTikTokAnalysis !== false;
          campaign.enableYoutubeAnalysis = settings.enableYoutubeAnalysis !== false;
          campaign.enableFbAnalysis = settings.enableFbAnalysis !== false;
          campaign.enableLinkedInAnalysis = settings.enableLinkedInAnalysis !== false;
          campaign.enableTwitterAnalysis = settings.enableTwitterAnalysis !== false;
          campaign.enableXHSAnalysis = settings.enableXHSAnalysis !== false;
          campaign.enableLemonAnalysis = settings.enableLemonAnalysis !== false;
          campaign.enableOverallSection = respData.campaign_details.settings ? respData.campaign_details.settings.enableOverallSection : false;
          campaign.postAnalysisStatus = Object.assign({}, this.defaultPostsAnalysisStatus, respData.campaign_details.postAnalysisStatus || {})
          campaign.reelAnalysisStatus = Object.assign({}, this.defaultReelAnalysisStatus, respData.campaign_details.reelAnalysisStatus || {})
          campaign.storyAnalysisStatus = Object.assign({}, this.defaultStoryAnalysisStatus, respData.campaign_details.storyAnalysisStatus || {})
          campaign.tikTokAnalysisStatus = Object.assign({}, this.defaultTikTokAnalysisStatus, respData.campaign_details.tikTokAnalysisStatus || {})
          campaign.youtubeAnalysisStatus = Object.assign({}, this.defaultYoutubeAnalysisStatus, respData.campaign_details.youtubeAnalysisStatus || {})
          campaign.performanceAnalysisStatus = Object.assign({}, this.defaultPerformanceAnalysisStatus, respData.campaign_details.performanceAnalysisStatus || {})
          campaign.fbAnalysisStatus = Object.assign({}, this.defaultFbAnalysisStatus, respData.campaign_details.fbAnalysisStatus || {})
          campaign.linkedInAnalysisStatus = Object.assign({}, this.defaultLinkedInAnalysisStatus, respData.campaign_details.linkedInAnalysisStatus || {})
          campaign.twitterAnalysisStatus = Object.assign({}, this.defaultTwitterAnalysisStatus, respData.campaign_details.twitterAnalysisStatus || {})
          campaign.xhsAnalysisStatus = Object.assign({}, this.defaultXHSAnalysisStatus, respData.campaign_details.xhsAnalysisStatus || {})
          campaign.lemonAnalysisStatus = Object.assign({}, this.defaultLemonAnalysisStatus, respData.campaign_details.lemonAnalysisStatus || {})
          campaign.startDate = respData.campaign_details.startDate || ''
          campaign.endDate = respData.campaign_details.endDate || ''
          campaign.optionalRemarks = respData.campaign_details.optionalRemarks || ''
          campaign.kpi = {
            engagement: Number(respData.campaign_details.engagement),
            outreach: Number(respData.campaign_details.outreach),
            minContent: respData.campaign_details.min_content,
            maxContent: respData.campaign_details.max_content,
            content: `${respData.campaign_details.min_content} to ${respData.campaign_details.max_content}`,
            benchmarkTitle: respData.campaign_details.benchmark ? respData.campaign_details.benchmark.title : '-',
            benchmarkValue: respData.campaign_details.benchmark ? respData.campaign_details.benchmark.value : '-'
          }
          campaign.summary = respData.summary;
          campaign.client = {
            name: respData.client.name,
            logo: respData.client.logo
          }
          // let posts = []
          // respData.posts.map(post => {
          //   if (post.reportGroup) {
          //     posts.push(...post.reports)
          //   } else {
          //     posts.push(post)
          //   }
          // })
          // posts = posts.map((post, index) => {
          //   return this.calculatePostData(post, index)
          // })
          let posts = []
          // respData.posts = respData.posts.filter(p => !p.isOthers)
          respData.posts = respData.posts.map((post, index) => {
            if (post.reportGroup) {
              post.panel = [0]
              post.reports = post.reports.map(groupPost => {
                groupPost = this.calculatePostData(groupPost, index)
                return groupPost
              })
              posts.push(...post.reports)
            } else {
              post = this.calculatePostData(post, index)
              posts.push(post)
            }
            return post
          }) 
          
          // Sort campaignPosts by type and lineUpIndex while keeping structure
          const typeOrder = ['post/carousel', 'reel', 'story', 'tiktok', 'youtube', 'facebook', 'linkedin', 'twitter', 'xhs', 'lemon', 'gdrive', 'others']
          this.campaignPosts = respData.posts.sort((a, b) => {
            // Determine type for each post/group
            const aType = a.reportGroup && a.reports && a.reports.length > 0 ? a.reports[0].type : a.type
            const bType = b.reportGroup && b.reports && b.reports.length > 0 ? b.reports[0].type : b.type
            
            // Get the position in the typeOrder array
            const aTypeIndex = typeOrder.indexOf(aType)
            const bTypeIndex = typeOrder.indexOf(bType)
            const aOrder = aTypeIndex !== -1 ? aTypeIndex : 999
            const bOrder = bTypeIndex !== -1 ? bTypeIndex : 999
            
            // First sort by type order
            if (aOrder !== bOrder) {
              return aOrder - bOrder
            }
            
            // Then sort by lineUpIndex within the same type
            const aIndex = a.lineUpIndex !== undefined ? a.lineUpIndex : (a.reports && a.reports[0] ? a.reports[0].lineUpIndex : 999999)
            const bIndex = b.lineUpIndex !== undefined ? b.lineUpIndex : (b.reports && b.reports[0] ? b.reports[0].lineUpIndex : 999999)
            return aIndex - bIndex
          })
          
          this.reportData.campaign = Object.assign({}, campaign)
          // posts / carousel
          this.postsAnalysisData = posts.filter(post => (post.type !== 'story' && post.type !== 'tiktok' && post.type !== 'youtube' && post.type !== 'xhs' && post.type !== 'lemon' && post.type !== 'facebook' && post.type !== 'linkedin' && post.type !== 'twitter' && post.type !== 'gdrive' && post.type !== 'reel')) // for post summary
          this.postsAnalysisData.map(post => {
            post.new_engagement_rate = Number((((post.likes + post.comments + post.saved + post.shares) / post.outreach) * 100).toFixed(2))
            post.new_engagement_rate_view = Number((((post.views) / post.outreach) * 100).toFixed(2))
            post.engagement_rate_reach = Number((((post.likes + post.comments + post.saved + post.shares) / post.reach) * 100).toFixed(2))
            post.interactions = ((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0))
          })
          this.postsAnalysisData = this.postsAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          // Reel
          this.reelAnalysisData = posts.filter(post => post.type === 'reel') // for reel summary
          this.reelAnalysisData.map(post => {
            post.interactions = Number(post.likes + post.comments + post.saved + post.shares)
            post.new_engagement_rate = Number((((post.likes + post.comments + post.saved + post.shares) / post.outreach) * 100).toFixed(2))
            post.interaction_rate_plays = 0
            if (post.views) {
              post.interaction_rate_plays = Number((((post.likes + post.comments + post.saved + post.shares) / Number(post.views)) * 100).toFixed(2))
            }
            post.engagement_rate_reach = Number((((post.likes + post.comments + post.saved + post.shares) / Number(post.reach)) * 100).toFixed(2))
            post.new_engagement_rate_view = Number((((post.views) / post.outreach) * 100).toFixed(2))
          })
          this.reelAnalysisData = this.reelAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          // TikTok
          this.tikTokAnalysisData = posts.filter(post => (post.type === 'tiktok')) // for post summary
          this.tikTokAnalysisData.map(post => {
            post.new_engagement_rate = ((((post.likes || 0) + (post.comments || 0) + (post.shares || 0)) / (post.outreach || 0)) * 100).toFixed(2)
            post.interactions = Number((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0))
            post.interaction_rate_plays = 0
            post.eng_rate_total_viewers = 0
            if (post.views) {
              post.interaction_rate_plays = ((((post.likes || 0) + (post.comments || 0) + (post.shares || 0)) / Number(post.views)) * 100).toFixed(2)
              post.eng_rate_total_viewers = ((((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0)) / Number(post.reach)) * 100).toFixed(2)
            }
            post.new_engagement_rate_view = Number((((post.views) / post.outreach) * 100).toFixed(2))
          })
          this.tikTokAnalysisData = this.tikTokAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          // Youtube
          this.youtubeAnalysisData = posts.filter(post => (post.type === 'youtube')) // for youtube summary
          this.youtubeAnalysisData.map(post => {
            post.new_engagement_rate = ((((post.likes || 0) + (post.comments || 0)) / (post.outreach || 0)) * 100).toFixed(2)
            post.new_engagement_rate_view = Number((((post.views) / post.outreach) * 100).toFixed(2))
            post.interactions = Number(((post.likes || 0) + (post.comments || 0)))
          })
          this.youtubeAnalysisData = this.youtubeAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          // Story Analysis
          this.storyAnalysisData = posts.filter(post => (post.type === 'story' || post.type === 'gdrive')) // for story summary
          this.storyAnalysisData.map(post => {
            post.interactions = ((post.shares || 0) + (post.replies || 0) + (post.link_clicks || 0) + (post.sticker_taps || 0) + (post.story_likes || 0))
            post.new_engagement_rate = ((((post.interactions || 0)) / (post.outreach || 0)) * 100).toFixed(2)
          })
          this.storyAnalysisData = this.storyAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          // FB Analysis
          this.fbAnalysisData = posts.filter(post => (post.type === 'facebook')) // for xhs summary
          this.fbAnalysisData.map(post => {
            post.interactions = ((post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0))
          })
          this.fbAnalysisData = this.fbAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          // LinkedIn Analysis
          this.linkedInAnalysisData = posts.filter(post => post.type === 'linkedin')
          this.linkedInAnalysisData.map(post => {
            post.interactions = ((post.like_count || 0) + (post.comment_count || 0) + (post.shares || 0))
          })
          this.linkedInAnalysisData = this.linkedInAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          // X Analysis
          this.twitterAnalysisData = posts.filter(post => post.type === 'twitter')
          this.twitterAnalysisData.forEach(post => {
            post.interactions = ((post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0))
          })
          this.twitterAnalysisData = this.twitterAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          // XHS Analysis
          this.xhsAnalysisData = posts.filter(post => (post.type === 'xhs')) // for xhs summary
          this.xhsAnalysisData.map(post => {
            post.interactions = ((post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0))
          })
          this.xhsAnalysisData = this.xhsAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          // Lemon Analysis
          this.lemonAnalysisData = posts.filter(post => (post.type === 'lemon')) // for lemon summary
          this.lemonAnalysisData.map(post => {
            post.interactions = ((post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0))
          })
          this.lemonAnalysisData = this.lemonAnalysisData.sort((a, b) => a.lineUpIndex - b.lineUpIndex)
          let grandOutreach = 0;
          let grandEngagement = 0;
          let totalImpressions = 0;
          this.postsAnalysisData.forEach(post => {
            grandOutreach += post.outreach ? Number(post.outreach) : 0
            grandEngagement += ((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0))
            totalImpressions += Number(post.impressions || 0)
          });
          this.reelAnalysisData.forEach(post => {
            grandOutreach += post.outreach ? Number(post.outreach) : 0
            grandEngagement += ((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0))
            totalImpressions += Number(post.impressions || 0) + Number(post.views || 0)
          });
          this.tikTokAnalysisData.forEach(post => {
            grandOutreach += post.outreach ? Number(post.outreach) : 0
            grandEngagement += ((post.likes || 0) + (post.comments || 0) + (post.saved || 0) + (post.shares || 0))
            totalImpressions += Number(post.impressions || 0) + Number(post.views || 0)
          });
          this.youtubeAnalysisData.forEach(post => {
            grandOutreach += post.outreach ? Number(post.outreach) : 0
            grandEngagement += ((post.likes || 0) + (post.comments || 0))
            totalImpressions += Number(post.impressions || 0)
          });
          this.storyAnalysisData.forEach(story => {
            grandOutreach += story.outreach ? Number(story.outreach) : 0
            grandEngagement += ((story.shares || 0) + (story.replies || 0) + (story.link_clicks || 0) + (story.sticker_taps || 0))
            totalImpressions += Number(story.impressions || 0)
          });
          this.xhsAnalysisData.forEach(post => {
            grandOutreach += post.outreach ? Number(post.outreach) : 0
            grandEngagement += ((post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0))
            totalImpressions += Number(post.impressions || 0)
          });
          this.lemonAnalysisData.forEach(post => {
            grandOutreach += post.outreach ? Number(post.outreach) : 0
            grandEngagement += ((post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0))
            totalImpressions += Number(post.impressions || 0)
          });
          this.fbAnalysisData.forEach(post => {
            grandOutreach += post.outreach ? Number(post.outreach) : 0
            grandEngagement += ((post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0))
            totalImpressions += Number(post.impressions || 0)
          });
          this.linkedInAnalysisData.forEach(post => {
            grandEngagement += ((post.like_count || 0) + (post.comment_count || 0) + (post.shares || 0))
          });
          this.twitterAnalysisData.forEach(post => {
            grandOutreach += post.outreach ? Number(post.outreach) : 0
            grandEngagement += ((post.like_count || 0) + (post.comment_count || 0) + (post.bookmarks || 0) + (post.shares || 0))
            totalImpressions += Number(post.views || 0)
          })
          this.reportData.campaign.summary.engagement = grandEngagement
          this.reportData.campaign.summary.outreach = grandOutreach
          this.reportData.campaign.summary.outreachImpressions = Number(grandOutreach + totalImpressions)
          this.isLoading = false;
        }
      } catch (err) {
        this.isLoading = false
        console.error(err)
      }
    },
    // async getCampaignPosts($state) {
    //   let force = false;
    //   let campaignID = this.$route.query.id
    //   this.isLoading = true;
    //   try {
    //     let response;
    //     if (this.isLoggedIn) {
    //       response = await campaignAPIs.generateCampaignReport(campaignID, this.page, force)
    //     } else {
    //       response = await campaignAPIs.generateCampaignHTMLReport(campaignID, this.passcode, this.page, force)
    //     }
    //     if (response.success) {
    //       let respData = response.data;
    //       if (respData.posts.length) {
    //         respData.posts.map(post => {
    //           if (post.reportGroup) {
    //             this.allPosts.push(...post.reports)
    //           } else {
    //             this.allPosts.push(post)
    //           }
    //         })
    //         this.page += 1
    //         this.allPosts = this.allPosts.map((post, index) => {
    //           return this.calculatePostData(post, index)
    //         })
    //         // group campaign posts
    //         // console.log(respData.posts)
    //         respData.posts = respData.posts.map((p, index) => {
    //           if (p.reportGroup) {
    //             let groupIndex = this.campaignPosts.findIndex(c => c.reportGroup && c.id === p.id)
    //             p.reports = p.reports.map(rp => {
    //               let postOne = this.allPosts.find(cp => cp.id === rp.id)
    //               rp = postOne
    //               return rp
    //             })
    //             p.panel = [0]
    //             if (groupIndex >= 0) {
    //               this.campaignPosts[groupIndex].reports.push(...p.reports)
    //             } else {
    //               this.campaignPosts.push(p)
    //             }
    //           } else {
    //             let postOne = this.allPosts.find(cp => cp.id === p.id)
    //             p = postOne
    //             this.campaignPosts.push(p)
    //           }
    //           return p
    //         })
    //         // this.campaignPosts.push(...respData.posts)
    //         if ($state) {
    //           $state.loaded();
    //         } else {
    //           this.infiniteId += 1
    //         }
    //       } else {
    //         if ($state) {
    //           $state.complete();
    //         }
    //       }
    //     }
    //   } catch (err) {
    //     this.isLoading = false
    //     console.error(err)
    //   }
    // },
    calculatePostData(post, index) {
      const platform = getReportPlatform(post)
      let postData = {}
      postData.id = post.id
      postData.campaignID = post.campaignID
      postData.key = index
      postData.lineUpIndex = post.lineUpIndex
      postData.groupID = post.groupID
      postData.groupName = post.groupName
      const profileOwner = post.owner || (post.post_details || {}).owner || {}
      postData.profileUrl = getReportProfileUrl(post, platform || (post.isTikTok ? 'tiktok' : 'instagram'))
      postData.profilePlatform = post.profilePlatform || post.profile_platform || profileOwner.platform || (post.influencer_details || {}).platform || ''
      postData.profileHandle = post.profileHandle || post.profile_handle || (post.influencer_details || {}).instagramHandle || profileOwner.username || ''
      if (post.isCalculated) {
        return post
      }
      if (!['linkedin', 'twitter'].includes(platform) && !post.isStory && !post.isTikTok && !post.isMultipleContents && !post.isYoutube && !post.isXHS && !post.isLemon && !post.isFacebook && !post.isOthers) {
        postData.name = post.post_details.owner.username
        postData.url = post.post_details.link
        postData.impressions = 0 // currently no used
        postData.engagement = post.currentInsight.engagement || 0
        postData.reach = 0 // currently no used
        postData.likes = post.currentInsight.like_count || 0
        postData.comments = post.currentInsight.comment_count || 0
        postData.outreach = post.currentInsight.outreach || 0
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1
        postData.engagement_rate_sd = post.post_details.owner.engagement_rate_sd || null
        postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0
        postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0
        postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
        postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0
        if (post.postType === 'IGR') {
          postData.type = 'reel'
          postData.title = 'IG Reel'
        } else {
          postData.type = 'post/carousel'
          postData.title = 'IG Post'
        }
        // for manual input data for posts
        if (post.inputtedInsights) {
          postData.saved = post.inputtedInsights.saved
          postData.shares = post.inputtedInsights.shares
          postData.views = post.inputtedInsights.views || 0 // newly added views, so there could be null
          postData.reach = post.inputtedInsights.reach || 0
          postData.impressions = post.inputtedInsights.impressions || 0
          postData.plays = post.inputtedInsights.plays || 0
          postData.watches = post.inputtedInsights.watches ? campaignHelper.parseWatchTime(post.inputtedInsights.watches) : 0
        } else {
          postData.saved = post.graphInsight ? post.graphInsight.saved : 0 // bookmarks
          postData.shares = 0 // no data default to 0
          postData.views = 0 // no data default to 0
        }
      } else if (post.isStory && post.insights) {
        postData.name = post.owner.username
        postData.outreach = post.owner.followers || post.owner.followers_sd
        postData.title = 'IG Story'
        postData.url = post.media_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.engagement = Number(post.insights.engagement) || 0
        postData.impressions = Number(post.insights.impressions) || 0
        postData.story_likes = Number(post.insights.story_likes) || 0
        postData.reach = Number(post.insights.reach) || 0
        postData.replies = Number(post.insights.replies) || 0
        postData.exits = Number(post.insights.exits) || 0
        postData.taps_back = Number(post.insights.taps_back) || 0
        postData.taps_forward = Number(post.insights.taps_forward) || 0
        postData.shares = Number(post.insights.shares) || 0
        postData.sticker_taps = Number(post.insights.sticker_taps) || 0
        postData.link_clicks = Number(post.insights.link_clicks) || 0
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
        postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0
        postData.type = 'story'
        postData.engagement_rate_sd = Number(post.owner.engagement_rate_sd) || 1
        postData.storyTotalInteractions = postData.link_clicks + postData.replies + postData.shares + postData.sticker_taps + postData.story_likes
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
        postData.public_id = post.public_id || null
      } else if (post.isTikTok) {
        postData.name = post.owner.username
        postData.title = 'TikTok Post'
        postData.url = post.post_details.link
        postData.shortCode = post.post_details.shortcode
        postData.impressions = 0 // currently no used
        postData.engagement = post.currentInsight.engagement || 0
        postData.reach = 0 // currently no used
        postData.likes = post.currentInsight.like_count || 0
        postData.comments = post.currentInsight.comment_count || 0
        postData.shares = post.currentInsight.shares || 0
        postData.views = post.currentInsight.views || 0
        postData.outreach = post.currentInsight.outreach || 0
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1
        postData.engagement_rate_sd = post.owner.engagement_rate_sd || null
        postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0
        postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0
        postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
        postData.avg_saves = post.avg_saves ? Number(post.avg_saves) : 0
        postData.avg_shares = post.avg_shares ? Number(post.avg_shares) : 0
        postData.type = 'tiktok'
        // for manual input data for posts
        if (post.inputtedInsights) {
          postData.saved = post.inputtedInsights.saved
          if (postData.shares === 0) {
            postData.shares = post.inputtedInsights.shares
          }
          if (postData.views === 0) {
            postData.views = post.inputtedInsights.views || 0 // newly added views, so there could be null
          }
          postData.reach = post.inputtedInsights.reach || 0
          postData.impressions = post.inputtedInsights.impressions || 0
          postData.plays = post.inputtedInsights.plays || 0
          postData.watches = post.inputtedInsights.watches ? campaignHelper.parseWatchTime(post.inputtedInsights.watches) : 0
          postData.watchedFullVideo = post.inputtedInsights.watchedFullVideo || 0
          postData.photo_views = post.inputtedInsights.photo_views || 0
        } else {
          postData.saved = post.graphInsight ? post.graphInsight.saved : 0 // bookmarks
          postData.shares = 0 // no data default to 0
          postData.views = 0 // no data default to 0
          postData.reach = 0
          postData.impressions = 0
          postData.plays = 0
          postData.watches = 0
          postData.watchedFullVideo = 0
        }
      } else if (post.isYoutube) {
        postData.name = post.owner.username
        postData.title = 'Youtube Post'
        postData.url = post.post_details.link
        postData.shortCode = post.post_details.shortcode
        postData.type = 'youtube'
        postData.impressions = 0 // currently no used
        postData.engagement = post.currentInsight.engagement || 0
        postData.reach = 0 // currently no used
        postData.likes = post.currentInsight.like_count || 0
        postData.comments = post.currentInsight.comment_count || 0
        postData.views = post.currentInsight.views || 0
        postData.outreach = post.currentInsight.outreach || 0
        postData.engagement_rate = post.currentInsight ? Number(post.currentInsight.engagement_rate) : 1
        postData.engagement_rate_sd = post.owner.engagement_rate_sd || null
        postData.median_engagement_rate = post.median_engagement_rate ? Number(post.median_engagement_rate) : 0
        postData.avg_likes = post.avg_likes ? Number(post.avg_likes) : 0
        postData.avg_comments = post.avg_comments ? Number(post.avg_comments) : 0
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
        // for manual input data for posts, currently no used
        // if (post.inputtedInsights) {
        //   postData.outreach = post.inputtedInsights.outreach || 0
        //   postData.engagement_rate = post.inputtedInsights.engagement_rate || 0
        //   postData.like_count = post.inputtedInsights.like_count || 0
        //   postData.comment_count = post.inputtedInsights.comment_count || 0
        //   postData.reach = post.inputtedInsights.reach || 0
        //   postData.impressions = post.inputtedInsights.impressions || 0
        // } else {
        //   postData.outreach = 0 // no data default to 0
        //   postData.engagement_rate = 0 // no data default to 0
        //   postData.like_count = 0 // no data default to 0
        //   postData.comment_count = 0 // no data default to 0
        //   postData.reach = 0
        //   postData.impressions = 0
        // }
      } else if (post.isFacebook && post.insights) {
        postData.name = post.owner.username
        postData.outreach = post.owner.followers || post.owner.followers_sd
        postData.title = 'Facebook'
        postData.url = post.media_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.outreach = Number(post.insights.outreach) || 0
        postData.like_count = Number(post.insights.like_count) || 0
        postData.comment_count = Number(post.insights.comment_count) || 0
        postData.views = Number(post.insights.views) || 0
        postData.shares = Number(post.insights.shares) || 0
        postData.bookmarks = Number(post.insights.bookmarks) || 0
        postData.type = 'facebook'
      } else if (post.isXHS && post.insights) {
        postData.name = post.owner.fullName || post.owner.username
        postData.outreach = post.owner.followers ? Number(post.owner.followers) : post.owner.followers_sd
        postData.title = 'XHS'
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
        postData.embed_url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.xhsLink = post.xhsLink || ''
        postData.like_count = Number(post.insights.like_count) || 0
        postData.comment_count = Number(post.insights.comment_count) || 0
        postData.views = Number(post.insights.views) || 0
        postData.watches = Number(post.insights.watches) || 0
        postData.shares = Number(post.insights.shares) || 0
        postData.bookmarks = Number(post.insights.bookmarks) || 0
        postData.type = 'xhs'
        postData.isXHS = true
      } else if (post.isLemon && post.insights) {
        postData.name = post.owner.fullName || post.owner.username
        postData.outreach = post.owner.followers ? Number(post.owner.followers) : post.owner.followers_sd
        postData.title = 'Lemon8'
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
        postData.embed_url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.lemonLink = post.lemonLink || ''
        postData.like_count = Number(post.insights.like_count) || 0
        postData.comment_count = Number(post.insights.comment_count) || 0
        postData.views = Number(post.insights.views) || 0
        postData.watches = Number(post.insights.watches) || 0
        postData.shares = Number(post.insights.shares) || 0
        postData.bookmarks = Number(post.insights.bookmarks) || 0
        postData.type = 'lemon'
        postData.isLemon = true
      } else if (platform === 'twitter' && post.insights) {
        const rawUrl = post.postLink || post.postURL || post.post_details || ''
        const latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null
        const insightData = latestInsight && latestInsight.data ? latestInsight.data : post.insights
        const insights = Object.assign({}, insightData || {}, post.currentInsight || {}, post.inputtedInsights || {})
        postData.name = post.owner.username || post.owner.fullName
        postData.title = 'X (Twitter)'
        postData.url = typeof rawUrl === 'string' ? rawUrl : (rawUrl.link || rawUrl.url || rawUrl.href || '')
        postData.outreach = Number(post.owner.followers || insights.outreach) || 0
        postData.like_count = Number(insights.like_count) || 0
        postData.comment_count = Number(insights.comment_count) || 0
        postData.impressions = Number(insights.impressions != null ? insights.impressions : insights.views) || 0
        postData.views = postData.impressions
        postData.shares = Number(insights.shares) || 0
        postData.bookmarks = Number(insights.saved || insights.bookmarks) || 0
        postData.interactions = postData.like_count + postData.comment_count + postData.shares + postData.bookmarks
        postData.type = 'twitter'
      } else if (platform === 'linkedin' && post.insights) {
        const rawUrl = post.postLink || post.postURL || post.post_details || ''
        const latestInsight = Array.isArray(post.insights) ? post.insights[post.insights.length - 1] : null
        const insightData = latestInsight && latestInsight.data ? latestInsight.data : post.insights
        const insights = Object.assign({}, insightData || {}, post.currentInsight || {}, post.inputtedInsights || {})
        postData.name = post.owner.username || post.owner.fullName
        postData.linkedinHandle = post.owner.linkedinHandle || post.owner.handle || post.owner.username
        postData.linkedinURL = post.owner.linkedinURL || post.owner.linkedinUrl || post.owner.profileURL || post.owner.profileUrl || post.owner.profile_url ||
          (post.owner.linkedin && (post.owner.linkedin.linkedinURL || post.owner.linkedin.linkedinUrl || post.owner.linkedin.profileUrl || post.owner.linkedin.profile_url))
        postData.title = 'LinkedIn'
        postData.url = typeof rawUrl === 'string'
          ? rawUrl
          : (rawUrl.link || rawUrl.url || rawUrl.href || '')
        postData.like_count = Number(insights.like_count) || 0
        postData.comment_count = Number(insights.comment_count) || 0
        postData.impressions = Number(insights.impressions) || 0
        postData.reach = Number(insights.reach != null ? insights.reach : insights.outreach) || 0
        postData.video_views = Number(insights.video_views) || 0
        postData.profile_viewers = Number(insights.profile_viewers) || 0
        postData.shares = Number(insights.shares) || 0
        postData.bookmarks = Number(insights.saved || insights.bookmarks) || 0
        postData.saved = postData.bookmarks
        postData.interactions = postData.like_count + postData.comment_count + postData.shares + postData.bookmarks
        postData.type = 'linkedin'
      } else if (post.isOthers && post.insights) {
        postData.name = post.owner.fullName || post.owner.username
        postData.outreach = Number(post.insights.outreach) || 0
        postData.title = 'Others'
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
        postData.embed_url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.postLink = post.postLink || ''
        postData.like_count = Number(post.insights.like_count) || 0
        postData.comment_count = Number(post.insights.comment_count) || 0
        postData.views = Number(post.insights.views) || 0
        postData.watches = Number(post.insights.watches) || 0
        postData.shares = Number(post.insights.shares) || 0
        postData.bookmarks = Number(post.insights.saved) || 0
        postData.plays = Number(post.insights.plays) || 0
        postData.type = 'others'
        postData.isOthers = true
      } else if (post.isMultipleContents) {
        postData.name = post.owner.username
        postData.outreach = post.owner.followers || post.owner.followers_sd
        postData.title = 'IG Story'
        postData.url = post.embed_url || `https://app.getkobe.com/static/img/kobe_white.png`
        postData.type = 'gdrive'
        postData.media_type = post.media_type ? post.media_type.toLowerCase() : null
        postData.public_id = post.public_id || null
        postData.avg_views = post.avg_views ? Number(post.avg_views) : 0
        postData.avg_reels_plays = post.avg_reels_plays ? Number(post.avg_reels_plays) : 0
        if (post.insights) {
          postData.engagement = Number(post.insights.engagement) || 0
          postData.impressions = Number(post.insights.impressions) || 0
          postData.reach = Number(post.insights.reach) || 0
          postData.replies = Number(post.insights.replies) || 0
          postData.exits = Number(post.insights.exits) || 0
          postData.taps_back = Number(post.insights.taps_back) || 0
          postData.taps_forward = Number(post.insights.taps_forward) || 0
          postData.shares = Number(post.insights.shares) || 0
          postData.sticker_taps = Number(post.insights.sticker_taps) || 0
          postData.link_clicks = Number(post.insights.link_clicks) || 0
          postData.engagement_rate_sd = Number(post.owner.engagement_rate_sd) || 1
          postData.storyTotalInteractions = postData.link_clicks + postData.replies + postData.shares + postData.sticker_taps
        }
      }
      postData.live_date = post.live_date ? utils.func.formatDate(post.live_date) : '-'
      postData.isCalculated = true
      return postData
    },
    loggedIn(passcode) {
      this.loginModalDialog = false
      this.passcode = passcode
      this.addPasscodeToLocalStorage(this.passcode)
      this.getCampaignReport()
      // this.getCampaignPosts()
    },
    addPasscodeToLocalStorage(passcode) {
      let campaignID = this.campaignID
      let localPasscodeString = window.localStorage.getItem('reportauth') || 'null'
      let localPasscodes = localPasscodeString !== 'null' ? JSON.parse(localPasscodeString) : {}
      localPasscodes[campaignID] = passcode
      localStorage.setItem('reportauth', JSON.stringify(localPasscodes))
    },
    removePasscodeFromLocalStorage(campaignID) {
      let localPasscodeString = window.localStorage.getItem('reportauth') || 'null'
      let localPasscodes = localPasscodeString !== 'null' ? JSON.parse(localPasscodeString) : {}
      delete localPasscodes[campaignID]
      localStorage.setItem('reportauth', JSON.stringify(localPasscodes))
    },
    checkPasscodeLoggedIn() {
      this.isLoading = true;
      let campaignID = this.campaignID
      let localPasscodeString = window.localStorage.getItem('reportauth') || 'null'
      let localPasscodes = localPasscodeString !== 'null' ? JSON.parse(localPasscodeString) : {}
      if (!localPasscodes.hasOwnProperty(campaignID)) {
        this.isLoading = false
        this.loginModalDialog = true
        return
      }
      let passcode = ''
      Object.keys(localPasscodes).forEach(key => {
        if (key === campaignID) {
          passcode = localPasscodes[key]
        }
      });
      campaignAPIs
      .loginCampaignReport(campaignID, passcode)
      .then(response => {
        if (response.success) {
          this.isLoading = false
          this.loggedIn(passcode)
        }
      })
      .catch(error => {
        this.isLoading = false
        this.removePasscodeFromLocalStorage(campaignID)
        this.loginModalDialog = true
        this.$swal({
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || 'The saved passcode is no longer valid. Please enter it again.',
          type: 'error'
        });
        console.error(error);
      });
    },
    clearReportAuthLocalStorage() {
      if (window.localStorage.getItem('reportauth')) {
        window.localStorage.removeItem('reportauth')
      }
    }
  }
}
</script>
<style lang="scss" >
 body {
   background-color: black !important;
   overflow: hidden;
 }
 html {
  scroll-behavior: smooth;
 }

  .summary-section .col-header-title {
    float: left;
    padding-right: 5px;
  }
</style>
<style lang="scss" scoped>
    @font-face {
      font-family: Barlow-Regular;
      src: url('/static/fonts/Barlow/Barlow-Regular.ttf');
    }
    @font-face {
      font-family: Barlow-Medium;
      src: url('/static/fonts/Barlow/Barlow-Medium.ttf');
    }
    @font-face {
      font-family: Barlow-Italic;
      src: url('/static/fonts/Barlow/Barlow-Italic.ttf');
    }
    @font-face {
      font-family: Barlow-MediumItalic;
      src: url('/static/fonts/Barlow/Barlow-MediumItalic.ttf');
    }
    #campaign-report {
      font-family: Barlow-Regular;
      background-color: #000;
      height: 100%;
    }
    .fab-btn-up {
        display: none;
    }
    .report-nav-x-logo {
      display: block;
      width: 24px;
      height: 24px;
      background-color: var(--v-primary-base);
      -webkit-mask: url('/static/img/x-logo.svg') center / contain no-repeat;
      mask: url('/static/img/x-logo.svg') center / contain no-repeat;
    }
    .hero-container {
      background-color: #000;
      height: 100%;
    }
    .scroll {
        cursor: pointer;
        text-align: center;
        margin-top:10%;
        width: 40px;
        height: 40px;
        border: 2px solid #3F3FFF;
        border-radius: 50%;
        position: relative;
        animation: down 1.5s infinite;
        margin-left: auto;
        margin-right: auto;
        -webkit-animation: down 1.5s infinite;
        &::before {
            content: '';
            position: absolute;
            top: 10px;
            left: 11px;
            width: 12px;
            height: 12px;
            border-left: 2px solid #3F3FFF;
        border-bottom: 2px solid #3F3FFF;
            transform: rotate(-45deg);
        }
    }

    @keyframes down {
        0% {
            transform: translate(0);
        }
        20% {
            transform: translateY(15px);
        }
        40% {
            transform: translate(0);
        }
    }

    @-webkit-keyframes down {
        0% {
            transform: translate(0);
        }
        20% {
            transform: translateY(15px);
        }
        40% {
            transform: translate(0);
        }
    }
    .hero {
        // position: absolute;
        background-image: url('/static/img/report/html-rpt-bg.jpg');
        background-position: center center;
        background-color: #050000;
        background-repeat: no-repeat;
        // background-attachment: fixed;
        background-size: cover;
        width: 100%;
        height: 938px;
        box-shadow:inset 0 0 0 2000px rgba(32, 26, 26, 0.8);
    }
    .v-parallax__image {
        transform: none !important;
        width: 100% !important;
    }
    .hero-bg {
        background-color: #000000;
        width:100%;
    }

    .client {
        position: absolute;
        top:10px;
        padding-left:20px;
        padding-top:30px;
    }
    .client-name {
        color:white;
        margin-left:20px;
        font-size:30px;
        font-weight:400;
    }
    .client-logo {
          width: 250px;
    }
     .current-date {
        color:white;
        margin-left:20px;
        font-size:14px;
        font-weight:300;
    }

    .campaign {
        position: absolute;
        top:200px;
        width:100%;
        color:white;
        text-align: center;
        font-size:48px;
        font-weight: 600;
    }

    .objective-div {
        color:white;
        display: flex;
        margin-top:50px;
    }
    .objectives-title {
        font-size:30px;
        font-weight: 400;
        // margin-right: 100px;
        width:300px;
        // flex:1;
        text-align: left;
        margin-left: auto;
        margin-right: auto;
    }
    .objective {
        margin-top:18px;
        font-size: 20px;
        font-weight: 300;
        text-align: left;
    }
    .deliverable-title {
        text-align: left;
        font-size:30px;
        font-weight: 400;
        // margin-left: 100px;
        margin-left: auto;
        margin-right: auto;
    }
    .deliverable {
        margin-top:18px;
        font-size: 20px;
        font-weight: 300;
        text-align: left;
    }

    #indicator {
    //   padding-left: 10px;
      list-style-type: none;
      font-size:14px;
      line-height: 40px;
      color: white;
    }

    #sideNavContents {
        // width:150px;
        position:fixed;
        top: 60%;
        right:0px;
        z-index:1005;
        // background:#212121;
        // border:1px solid;
        // border-radius: 5px;
        // padding:7px;
        // opacity: 0.9;
    }

    #campaignSummary,
    #post,
    #postSummary,
    #storySummary,
    #tiktokSummary,
    #performance,
    .report-footer
     {
      background-color: rgb(0, 0, 0)  !important;
    }
    .report-footer {
      border-top: 1px solid #000;
      color: #fff;
      min-height: 140px;
    }
    .report-footer::v-deep .v-footer,
    .report-footer::v-deep .col {
      background-color: #000 !important;
    }
    // .group-title {
    //   color: rgb(255, 183, 77);
    //   font-size: 30px;
    //   border-bottom: 1px solid #212121;
    //   padding-bottom: 10px;
    // }

    /* Extra small devices (phones, 600px and down) */
    @media only screen and (max-width: 800px) {
        .hero-container {
            height: 400px;
        }
        .scroll {
            display:none;
            cursor: pointer;
            margin-top:0px;
            width: 20px;
	        height: 20px;
            &::before {
                content: '';
                position: absolute;
                top: 4px;
                left: 5px;
                width: 6px;
                height: 6px;
                border-left: 2px solid #3F3FFF;
                border-bottom: 2px solid #3F3FFF;
                transform: rotate(-45deg);
            }
        }
        .client {
            position: absolute;
            top:10px;
            width:100%;
            text-align:center;
            padding-left:0px;
            padding-top:10px;
        }
        .client-name {
            color:white;
            margin-left:20px;
            font-size:14px;
            font-weight:400;
        }
        .client-logo {
          width: 150px;
          margin-left:auto;
          margin-right: auto;
        }
        .current-date {
            color:white;
            margin-left:20px;
            font-size:12px;
            font-weight:300;
        }

        .campaign {
            position: absolute;
            top:150px;
            width:100%;
            color:white;
            text-align: center;
            font-size: 16px;
            font-weight: 600;
        }

        .objective-div {
            margin-top:20px;
            width: 100%;
            color:white;
            display: block;
            padding:10px;
            left:0px;
        }

        .objectives-title {
            font-size:14px;
            font-weight: 400;
            margin-right: 100px;
            width:300px;
            flex:0;
            margin-left: 0;
            margin-right: 0;
        }

        .objective {
            margin-top:10px;
            font-size: 12px;
            font-weight: 300;
            text-align: left;
            width:100%;
        }

        .deliverable-title {
            font-size:14px;
            font-weight: 400;
            margin-left: 0px;
            margin-right: 0;
        }
        .deliverable {
            margin-top:10px;
            font-size: 12px;
            font-weight: 300;
            text-align: left;
        }
    }

    @media  (min-width: 800px) and (max-width: 1176px) {
         .hero-container {
            height: 550px;
        }
        .scroll {
            cursor: pointer;
            margin-top:20px;
            width: 20px;
	        height: 20px;
            &::before {
                content: '';
                position: absolute;
                top: 4px;
                left: 5px;
                width: 6px;
                height: 6px;
                border-left: 2px solid #3F3FFF;
                border-bottom: 2px solid #3F3FFF;
                transform: rotate(-45deg);
            }
        }
        .client {
            position: absolute;
            top:10px;
            padding-left:20px;
            padding-top:30px;
        }
        .client-name {
            color:white;
            margin-left:20px;
            font-size:20px;
            font-weight:400;
        }
        .client-logo {
            width: 200px;
        }
        .current-date {
            color:white;
            margin-left:20px;
            font-size:12px;
            font-weight:300;
        }

        .campaign {
            position: absolute;
            top:100px;
            width:100%;
            color:white;
            text-align: center;
            font-size:45px;
            font-weight: 600;
        }

        .objective-div {
            color:white;
            display: flex;
            margin-top:50px;
        }
        .objectives-title {
            font-size:25px;
            font-weight: 400;
            width:300px;
            text-align: left;
            margin-left: auto;
            margin-right: auto;
        }
        .objective {
            margin-top:18px;
            font-size: 16px;
            font-weight: 300;
            text-align: left;
        }
        .deliverable-title {
            text-align: left;
            font-size:25px;
            font-weight: 400;
            margin-left: auto;
            margin-right: auto;
        }
        .deliverable {
            margin-top:18px;
            font-size: 16px;
            font-weight: 300;
            text-align: left;
        }
    }

</style>



// WEBPACK FOOTER //
// index.vue?b78e633a